import { firebaseAction } from 'vuexfire'
import db from '@/plugins/db'

// initial state

const state = {
  audioRecorder: {
    transcribeEnable: false, // Added transcribeEnable flag
  },
}

// getters
const getters = {
  getRecorderStatus: (state) => () => {
    return (!state.audioRecorder) ? undefined : state.audioRecorder.status
  },
  getRecordingFlag: (state) => () => {
    return (!state.audioRecorder) ? undefined : state.audioRecorder.isRecording
  },
  getLowVolume: (state) => () => {
    return (!state.audioRecorder) ? undefined : state.audioRecorder.lowVolume
  },
  getHighVolume: (state) => () => {
    return (!state.audioRecorder) ? undefined : state.audioRecorder.highVolume
  },
  getRoomVolume: (state) => () => {
    return (!state.audioRecorder) ? undefined : state.audioRecorder.roomVolumePercent
  },
  getRecorderLastSeen: (state) => () => {
    return (!state.audioRecorder) ? undefined : state.audioRecorder.recorderLastSeen
  },
  getTranscribeEnable: (state) => () => {
    return (!state.audioRecorder) ? undefined : state.audioRecorder.transcribeEnable
  },
}

// actions
const actions = {
  bindAudioRecorder: firebaseAction(context => {
    return context.bindFirebaseRef('audioRecorder', db.ref('audio-recorder'))
  }),
  isAudioRecorderOnline: () => {
    const lastSeenTime = state.audioRecorder?.recorderLastSeen

    return db.ref('.info/serverTimeOffset').once('value')
      .then(offsetSnapshot => {
        const offset = offsetSnapshot.val() || 0
        const serverTime = Date.now() + offset

        const differenceInMilliseconds = serverTime - lastSeenTime

        if (differenceInMilliseconds > 12000) {
          return db.ref('audio-recorder').update({ status: 'Recorder is offline' })
            .then(() => false)
        }
        return true
      })
      .catch(error => {
        console.error('Error checking recorder status:', error)// Log any errors
      })
  },
  startRecording: ({ commit }, { hourNumber: hour, questionNumber: question }) => {
    if (actions.isAudioRecorderOnline()) {
      db.ref('audio-recorder').update({ isRecording: true })
      db.ref('audio-recorder').update({ hourNumber: hour })
      db.ref('audio-recorder').update({ questionNumber: question })
    }
  },
  stopRecording: ({ commit }) => {
    actions.isAudioRecorderOnline()
    db.ref('audio-recorder').update({ isRecording: false })
  },
  setRoomVolumeLow: ({ commit }) => {
    db.ref('audio-recorder').update({ roomVolumePercent: state.audioRecorder.lowVolume })
  },
  setRoomVolumeHigh: ({ commit }) => {
    db.ref('audio-recorder').update({ roomVolumePercent: state.audioRecorder.highVolume })
  },
  setNewLowVolume: ({ commit }, { lowVolume: value }) => {
    db.ref('audio-recorder').update({ lowVolume: value })
  },
  setNewHighVolume: ({ commit }, { highVolume: value }) => {
    db.ref('audio-recorder').update({ highVolume: value })
  },
  setRoomVolume: ({ commit }, { roomVolumePercent: value }) => {
    db.ref('audio-recorder').update({ roomVolumePercent: value })
  },
  setTranscribeEnable: ({ commit }, value) => {
    db.ref('audio-recorder').update({ transcribeEnable: value })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
}
